// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AddressSelectController from "./address_select_controller"
application.register("address-select", AddressSelectController)

import AiApplicantFilterController from "./ai_applicant_filter_controller"
application.register("ai-applicant-filter", AiApplicantFilterController)

import AiGeneratorController from "./ai_generator_controller"
application.register("ai-generator", AiGeneratorController)

import AiProfileStreamingController from "./ai_profile_streaming_controller"
application.register("ai-profile-streaming", AiProfileStreamingController)

import AiSummaryController from "./ai_summary_controller"
application.register("ai-summary", AiSummaryController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AnalyticsTooltipController from "./analytics_tooltip_controller"
application.register("analytics-tooltip", AnalyticsTooltipController)

import AnnouncementsController from "./announcements_controller"
application.register("announcements", AnnouncementsController)

import ApplicantCompetencySelectController from "./applicant_competency_select_controller"
application.register("applicant-competency-select", ApplicantCompetencySelectController)

import CcRecipientSelectController from "./cc_recipient_select_controller"
application.register("cc-recipient-select", CcRecipientSelectController)

import ApplicantDocsController from "./applicant_docs_controller"
application.register("applicant-docs", ApplicantDocsController)

import ApplicantSelectController from "./applicant_select_controller"
application.register("applicant-select", ApplicantSelectController)

import ApplicantsBulkController from "./applicants_bulk_controller"
application.register("applicants-bulk", ApplicantsBulkController)

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import AppliesBulkController from "./applies_bulk_controller"
application.register("applies-bulk", AppliesBulkController)

import AppSidebarController from "./app_sidebar_controller"
application.register("app-sidebar", AppSidebarController)

import ApplyCtaController from "./apply_cta_controller"
application.register("apply-cta", ApplyCtaController)

import AtlastitanOnboardingController from "./atlastitan_onboarding_controller"
application.register("atlastitan-onboarding", AtlastitanOnboardingController)

import AutoSaveToggleController from "./auto_save_toggle_controller"
application.register("auto-save-toggle", AutoSaveToggleController)

import AutoSelectController from "./auto_select_controller"
application.register("auto-select", AutoSelectController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import BmodalController from "./bmodal_controller"
application.register("bmodal", BmodalController)

import BulkActionController from "./bulk_action_controller"
application.register("bulk-action", BulkActionController)

import BulletCleanerController from "./bullet_cleaner_controller"
application.register("bullet-cleaner", BulletCleanerController)

import CandidatesFilterController from "./candidates_filter_controller"
application.register("candidates-filter", CandidatesFilterController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import CheckinButtonController from "./checkin_button_controller"
application.register("checkin-button", CheckinButtonController)

import CitySearchController from "./city_search_controller"
application.register("city-search", CitySearchController)

import CmodalController from "./cmodal_controller"
application.register("cmodal", CmodalController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import CommentsController from "./comments_controller"
application.register("comments", CommentsController)

import CompetenciesSelectController from "./competencies_select_controller"
application.register("competencies-select", CompetenciesSelectController)

import CompetencyCatalogueImportController from "./competency_catalogue_import_controller"
application.register("competency-catalogue-import", CompetencyCatalogueImportController)

import CompetencyRequirementsController from "./competency_requirements_controller"
application.register("competency-requirements", CompetencyRequirementsController)

import CompetencySelectController from "./competency_select_controller"
application.register("competency-select", CompetencySelectController)

import CompetencySelectionController from "./competency_selection_controller"
application.register("competency-selection", CompetencySelectionController)

import CompetencySliderController from "./competency_slider_controller"
application.register("competency-slider", CompetencySliderController)

import CompetencySortableController from "./competency_sortable_controller"
application.register("competency-sortable", CompetencySortableController)

import CompetencyValidationController from "./competency_validation_controller"
application.register("competency-validation", CompetencyValidationController)

import CompetencyWeightController from "./competency_weight_controller"
application.register("competency-weight", CompetencyWeightController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import ConnectController from "./connect_controller"
application.register("connect", ConnectController)

import ContactJobsiteSelectorController from "./contact_jobsite_selector_controller"
application.register("contact-jobsite-selector", ContactJobsiteSelectorController)

import ContactsController from "./contacts_controller"
application.register("contacts", ContactsController)

import ContextMenuController from "./context_menu_controller"
application.register("context-menu", ContextMenuController)

import ContractTypeVisibilityController from "./contract_type_visibility_controller"
application.register("contract-type-visibility", ContractTypeVisibilityController)

import CsvUploadController from "./csv_upload_controller"
application.register("csv-upload", CsvUploadController)

import CustomPropertyController from "./custom_property_controller"
application.register("custom-property", CustomPropertyController)

import CustomPropertyMultiselectController from "./custom_property_multiselect_controller"
application.register("custom-property-multiselect", CustomPropertyMultiselectController)

import CustomPropertyValidationController from "./custom_property_validation_controller"
application.register("custom-property-validation", CustomPropertyValidationController)

import CustomerContactsController from "./customer_contacts_controller"
application.register("customer-contacts", CustomerContactsController)

import CustomerDetailTabsController from "./customer_detail_tabs_controller"
application.register("customer-detail-tabs", CustomerDetailTabsController)

import CustomerDuplicateCheckerController from "./customer_duplicate_checker_controller"
application.register("customer-duplicate-checker", CustomerDuplicateCheckerController)

import CustomerRequisitionsTabSyncController from "./customer_requisitions_tab_sync_controller"
application.register("customer-requisitions-tab-sync", CustomerRequisitionsTabSyncController)

import CustomerStatusPopoverController from "./customer_status_popover_controller"
application.register("customer-status-popover", CustomerStatusPopoverController)

import CustomersController from "./customers_controller"
application.register("customers", CustomersController)

import DateController from "./date_controller"
application.register("date", DateController)

import DatetimeController from "./datetime_controller"
application.register("datetime", DatetimeController)

import DeletionDateRecalculationController from "./deletion_date_recalculation_controller"
application.register("deletion-date-recalculation", DeletionDateRecalculationController)

import DesignerController from "./designer_controller"
application.register("designer", DesignerController)

import DialogLoaderController from "./dialog_loader_controller"
application.register("dialog-loader", DialogLoaderController)

import DisableOnClickController from "./disable_on_click_controller"
application.register("disable-on-click", DisableOnClickController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DocumentsController from "./documents_controller"
application.register("documents", DocumentsController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import DynamicFiltersController from "./dynamic_filters_controller"
application.register("dynamic-filters", DynamicFiltersController)

import DynamicSelectController from "./dynamic_select_controller"
application.register("dynamic-select", DynamicSelectController)

import EmailAttachmentsController from "./email_attachments_controller"
application.register("email-attachments", EmailAttachmentsController)

import EmailPreviewerController from "./email_previewer_controller"
application.register("email-previewer", EmailPreviewerController)

import EmailValidatorController from "./email_validator_controller"
application.register("email-validator", EmailValidatorController)

import EmblaCarouselController from "./embla_carousel_controller"
application.register("embla-carousel", EmblaCarouselController)

import ExpressProfileToggleController from "./express_profile_toggle_controller"
application.register("express-profile-toggle", ExpressProfileToggleController)

import FadeOutController from "./fade_out_controller"
application.register("fade-out", FadeOutController)

import FeatureSearchController from "./feature_search_controller"
application.register("feature-search", FeatureSearchController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FilterCheckboxListController from "./filter_checkbox_list_controller"
application.register("filter-checkbox-list", FilterCheckboxListController)

import FilterPresetsController from "./filter_presets_controller"
application.register("filter-presets", FilterPresetsController)

import FilterBarController from "./filter_bar_controller"
application.register("filter-bar", FilterBarController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FlowyController from "./flowy_controller"
application.register("flowy", FlowyController)

import FollowerSearchController from "./follower_search_controller"
application.register("follower-search", FollowerSearchController)

import FrameClickController from "./frame_click_controller"
application.register("frame-click", FrameClickController)

import FreelancerToggleController from "./freelancer_toggle_controller"
application.register("freelancer-toggle", FreelancerToggleController)

import FrontendNestedFormController from "./frontend_nested_form_controller"
application.register("frontend-nested-form", FrontendNestedFormController)

import FunnelController from "./funnel_controller"
application.register("funnel", FunnelController)

import FunnelFilterController from "./funnel_filter_controller"
application.register("funnel-filter", FunnelFilterController)

import GlobalPopoverController from "./global_popover_controller"
application.register("global-popover", GlobalPopoverController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HovercardController from "./hovercard_controller"
application.register("hovercard", HovercardController)

import HrflowMatchTabsController from "./hrflow_match_tabs_controller"
application.register("hrflow-match-tabs", HrflowMatchTabsController)

import ImageSliderController from "./image_slider_controller"
application.register("image-slider", ImageSliderController)

import InfinitePageController from "./infinite_page_controller"
application.register("infinite-page", InfinitePageController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InquiryScorePopoverController from "./inquiry_score_popover_controller"
application.register("inquiry-score-popover", InquiryScorePopoverController)

import InteractionSidebarExpandController from "./interaction_sidebar_expand_controller"
application.register("interaction-sidebar-expand", InteractionSidebarExpandController)

import InteractionsController from "./interactions_controller"
application.register("interactions", InteractionsController)

import JobApprovalController from "./job_approval_controller"
application.register("job-approval", JobApprovalController)

import JobDescriptionGeneratorController from "./job_description_generator_controller"
application.register("job-description-generator", JobDescriptionGeneratorController)

import JobFormController from "./job_form_controller"
application.register("job-form", JobFormController)

import JobsCountController from "./jobs_count_controller"
application.register("jobs-count", JobsCountController)

import JobsChipsController from "./jobs_chips_controller"
application.register("jobs-chips", JobsChipsController)

import ChecklistAutofillController from "./checklist_autofill_controller"
application.register("checklist-autofill", ChecklistAutofillController)

import JobStatusButtonController from "./job_status_button_controller"
application.register("job-status-button", JobStatusButtonController)

import JobVideoUploadController from "./job_video_upload_controller"
application.register("job-video-upload", JobVideoUploadController)

import JobsiteSelectorController from "./jobsite_selector_controller"
application.register("jobsite-selector", JobsiteSelectorController)

import JsonUploadController from "./json_upload_controller"
application.register("json-upload", JsonUploadController)

import JsonValidatorController from "./json_validator_controller"
application.register("json-validator", JsonValidatorController)

import KanbanController from "./kanban_controller"
application.register("kanban", KanbanController)

import LayoutSelectorController from "./layout_selector_controller"
application.register("layout-selector", LayoutSelectorController)

import LazyLoadController from "./lazy_load_controller"
application.register("lazy-load", LazyLoadController)

import LegacySelectController from "./legacy_select_controller"
application.register("legacy-select", LegacySelectController)

import LinkPreviewController from "./link_preview_controller"
application.register("link-preview", LinkPreviewController)

import LinksController from "./links_controller"
application.register("links", LinksController)

import LoadingProgressController from "./loading_progress_controller"
application.register("loading-progress", LoadingProgressController)

import MatchAnimationController from "./match_animation_controller"
application.register("match-animation", MatchAnimationController)

import MatchFiltersController from "./match_filters_controller"
application.register("match-filters", MatchFiltersController)

import MatchesFrameOverlayController from "./matches_frame_overlay_controller"
application.register("matches-frame-overlay", MatchesFrameOverlayController)

import MeetingsController from "./meetings_controller"
application.register("meetings", MeetingsController)

import MentionsController from "./mentions_controller"
application.register("mentions", MentionsController)

import ModalTriggerController from "./modal_trigger_controller"
application.register("modal-trigger", ModalTriggerController)

import NationalityController from "./nationality_controller"
application.register("nationality", NationalityController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import NumericInputController from "./numeric_input_controller"
application.register("numeric-input", NumericInputController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

import OsKbdController from "./os_kbd_controller"
application.register("os-kbd", OsKbdController)

import OutlookCalendarController from "./outlook_calendar_controller"
application.register("outlook-calendar", OutlookCalendarController)

import ParserSandboxFormController from "./parser_sandbox_form_controller"
application.register("parser-sandbox-form", ParserSandboxFormController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PdfPreviewController from "./pdf_preview_controller"
application.register("pdf-preview", PdfPreviewController)

import PdfReaderController from "./pdf_reader_controller"
application.register("pdf-reader", PdfReaderController)

import PhoneNumberController from "./phone_number_controller"
application.register("phone-number", PhoneNumberController)

import PhonecallCardController from "./phonecall_card_controller"
application.register("phonecall-card", PhonecallCardController)

import PhonecallDialController from "./phonecall_dial_controller"
application.register("phonecall-dial", PhonecallDialController)

import PhonecallRecipientSearchController from "./phonecall_recipient_search_controller"
application.register("phonecall-recipient-search", PhonecallRecipientSearchController)

import PipelineStagesController from "./pipeline_stages_controller"
application.register("pipeline-stages", PipelineStagesController)

import PolicyRadioController from "./policy_radio_controller"
application.register("policy-radio", PolicyRadioController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ProfileCompetencyInlineController from "./profile_competency_inline_controller"
application.register("profile-competency-inline", ProfileCompetencyInlineController)

import ProfileCompetencySelectController from "./profile_competency_select_controller"
application.register("profile-competency-select", ProfileCompetencySelectController)

import ProfileDetailsController from "./profile_details_controller"
application.register("profile-details", ProfileDetailsController)

import ProfileEditorViewController from "./profile_editor_view_controller"
application.register("profile-editor-view", ProfileEditorViewController)

import ProfileLockController from "./profile_lock_controller"
application.register("profile-lock", ProfileLockController)

import ProfilePreviewController from "./profile_preview_controller"
application.register("profile-preview", ProfilePreviewController)

import ProfilePreviewOverlayController from "./profile_preview_overlay_controller"
application.register("profile-preview-overlay", ProfilePreviewOverlayController)

import QuickAccessController from "./quick_access_controller"
application.register("quick-access", QuickAccessController)

import QuoteFormController from "./quote_form_controller"
application.register("quote-form", QuoteFormController)

import QuoteRecipientAddressController from "./quote_recipient_address_controller"
application.register("quote-recipient-address", QuoteRecipientAddressController)

import QuoteSnippetsController from "./quote_snippets_controller"
application.register("quote-snippets", QuoteSnippetsController)

import QuoteTemplateSwitcherController from "./quote_template_switcher_controller"
application.register("quote-template-switcher", QuoteTemplateSwitcherController)

import RadioSelectionController from "./radio_selection_controller"
application.register("radio-selection", RadioSelectionController)

import RangeSliderController from "./range_slider_controller"
application.register("range-slider", RangeSliderController)

import RatingsController from "./ratings_controller"
application.register("ratings", RatingsController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import RejectApplyController from "./reject_apply_controller"
application.register("reject-apply", RejectApplyController)

import RelationshipTabsController from "./relationship_tabs_controller"
application.register("relationship-tabs", RelationshipTabsController)

import ReleaseNotesModalController from "./release_notes_modal_controller"
application.register("release-notes-modal", ReleaseNotesModalController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)

import RemoteFormController from "./remote_form_controller"
application.register("remote-form", RemoteFormController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ResizableController from "./resizable_controller"
application.register("resizable", ResizableController)

import ScrollHideController from "./scroll_hide_controller"
application.register("scroll-hide", ScrollHideController)

import ScrollToSearchController from "./scroll_to_search_controller"
application.register("scroll-to-search", ScrollToSearchController)

import ScrollToShowController from "./scroll_to_show_controller"
application.register("scroll-to-show", ScrollToShowController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SelectRevealController from "./select_reveal_controller"
application.register("select-reveal", SelectRevealController)

import SelectTitleController from "./select_title_controller"
application.register("select-title", SelectTitleController)

import SelectUserController from "./select_user_controller"
application.register("select-user", SelectUserController)

import SessionTimeoutController from "./session_timeout_controller"
application.register("session-timeout", SessionTimeoutController)

import ShortcutController from "./shortcut_controller"
application.register("shortcut", ShortcutController)

import ShowMoreListController from "./show_more_list_controller"
application.register("show-more-list", ShowMoreListController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SidebarToggleController from "./sidebar_toggle_controller"
application.register("sidebar-toggle", SidebarToggleController)

import SmoothScrollingController from "./smooth_scrolling_controller"
application.register("smooth-scrolling", SmoothScrollingController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SortableSelectController from "./sortable_select_controller"
application.register("sortable-select", SortableSelectController)

import StatController from "./stat_controller"
application.register("stat", StatController)

import SubjectableMultiselectController from "./subjectable_multiselect_controller"
application.register("subjectable-multiselect", SubjectableMultiselectController)

import SubjectableSearchController from "./subjectable_search_controller"
application.register("subjectable-search", SubjectableSearchController)

import TableHighlightController from "./table_highlight_controller"
application.register("table-highlight", TableHighlightController)

import TagSearchController from "./tag_search_controller"
application.register("tag-search", TagSearchController)

import TagsController from "./tags_controller"
application.register("tags", TagsController)

import TalentfinderController from "./talentfinder_controller"
application.register("talentfinder", TalentfinderController)

import TemplatesController from "./templates_controller"
application.register("templates", TemplatesController)

import TemplateUploadToggleController from "./template_upload_toggle_controller"
application.register("template-upload-toggle", TemplateUploadToggleController)

import TimeController from "./time_controller"
application.register("time", TimeController)

import TimelineController from "./timeline_controller"
application.register("timeline", TimelineController)

import TmodalController from "./tmodal_controller"
application.register("tmodal", TmodalController)

import ToastrController from "./toastr_controller"
application.register("toastr", ToastrController)

import TodoCompleteController from "./todo_complete_controller"
application.register("todo-complete", TodoCompleteController)

import TodoCompleteToggleController from "./todo_complete_toggle_controller"
application.register("todo-complete-toggle", TodoCompleteToggleController)

import TodoController from "./todo_controller"
application.register("todo", TodoController)

import TodoStatusController from "./todo_status_controller"
application.register("todo-status", TodoStatusController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToggleSwitchController from "./toggle_switch_controller"
application.register("toggle-switch", ToggleSwitchController)

import TomselectColoredController from "./tomselect_colored_controller"
application.register("tomselect-colored", TomselectColoredController)

import TomselectController from "./tomselect_controller"
application.register("tomselect", TomselectController)

import TomselectCreateController from "./tomselect_create_controller"
application.register("tomselect-create", TomselectCreateController)

import TomselectDynamicFilterFieldController from "./tomselect_dynamic_filter_field_controller"
application.register("tomselect-dynamic-filter-field", TomselectDynamicFilterFieldController)

import TomselectMultiplePoolsController from "./tomselect_multiple_pools_controller"
application.register("tomselect-multiple-pools", TomselectMultiplePoolsController)

import TomselectParticipantsController from "./tomselect_participants_controller"
application.register("tomselect-participants", TomselectParticipantsController)

import TomselectSearchController from "./tomselect_search_controller"
application.register("tomselect-search", TomselectSearchController)

import TomselectSortedController from "./tomselect_sorted_controller"
application.register("tomselect-sorted", TomselectSortedController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TrixFormController from "./trix_form_controller"
application.register("trix-form", TrixFormController)

import TrixPlaceholderController from "./trix_placeholder_controller"
application.register("trix-placeholder", TrixPlaceholderController)

import TurboFrameLoadingController from "./turbo_frame_loading_controller"
application.register("turbo-frame-loading", TurboFrameLoadingController)

import TurbolinksFormController from "./turbolinks_form_controller"
application.register("turbolinks-form", TurbolinksFormController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import UrlHelperController from "./url_helper_controller"
application.register("url-helper", UrlHelperController)

import ValidationController from "./validation_controller"
application.register("validation", ValidationController)

import VideoController from "./video_controller"
application.register("video", VideoController)

import ViewPreferencesController from "./view_preferences_controller"
application.register("view-preferences", ViewPreferencesController)

import WeightSelectController from "./weight_select_controller"
application.register("weight-select", WeightSelectController)

import WorkflowDesignerController from "./workflow_designer_controller"
application.register("workflow-designer", WorkflowDesignerController)

import WorkflowStepsController from "./workflow_steps_controller"
application.register("workflow-steps", WorkflowStepsController)

// Zuvor nur über require.context in packs/application.js geladen — hier ergänzt,
// damit index.js die vollständige Registry ist und require.context entfallen kann
// (sonst wurde jeder Controller doppelt registriert -> doppelte Instanzen).
import LockOnClickController from "./lock_on_click_controller"
application.register("lock-on-click", LockOnClickController)

import ProfileRequisitionSyncController from "./profile_requisition_sync_controller"
application.register("profile-requisition-sync", ProfileRequisitionSyncController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

// HMR: Controller-Änderungen ohne Full-Reload übernehmen.
// Ohne dieses Accept bubbelt ein Hot-Update eines Controllers nur bis hierher,
// ohne dass Stimulus die geänderte Klasse re-registriert -> die alte Implementierung
// bleibt aktiv ("stale controller"), bis man die Seite hart neu lädt. Mit dem
// Self-Accept evaluiert HMR dieses Modul neu (inkl. der geänderten Controller) und
// die application.register-Aufrufe re-registrieren jeden Identifier mit der neuen
// Klasse. In Production ist module.hot undefined -> No-op (wird wegoptimiert).
// Hinweis: bin/rails stimulus:manifest:update überschreibt diese Datei — diesen
// Block danach wieder anhängen.
if (module.hot) {
  module.hot.accept()
}
